
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "parts/Navbars/DefaultNavbar";
import DefaultFooter from "parts/Footers/DefaultFooter";

// About Us page sections
import Information from "pages/landing-pages/cyber-security/sections/Information";
import Team from "pages/landing-pages/cyber-security/sections/Team";
import Featuring from "pages/landing-pages/cyber-security/sections/Featuring";
import Newsletter from "pages/landing-pages/cyber-security/sections/Newsletter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";
import { Helmet } from 'react-helmet';
// Images
import bgImage from "assets/images/contact.jpg";
function WebDev() {
  return (
    <>
        <Helmet>
        <title>Cyber Security Services - HPTech Solutions</title>
        <meta name="description" content="Protect your business with HPTech Solutions' Cyber Security services. We offer comprehensive security solutions, including threat detection, risk management, and data protection." />
        <meta name="keywords" content="cyber security, data protection, threat detection, risk management, security solutions, HPTech Solutions" />
        <meta property="og:title" content="Cyber Security Services - HPTech Solutions" />
        <meta property="og:description" content="HPTech Solutions provides robust Cyber Security services to safeguard your business against online threats, hacking, and data breaches." />
        <meta property="og:image" content={bgImage} />
    </Helmet>
            <MKBox position="fixed" top="0.5rem" width="100%" zIndex="3">
        <DefaultNavbar
          routes={routes}
        />
      </MKBox>
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Cyber Security
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
            Comprehensive Protection Against Emerging Threats </MKTypography>
            
            <MKTypography variant="h6" color="white" mt={8} mb={1}>
            Our Security Services Includes
            </MKTypography>
            <MKBox display="flex" justifyContent="center" alignItems="center">
            <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
              <i className="fab fa-facebook" />
            </MKTypography>
            <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
              <i className="fab fa-instagram" />
            </MKTypography>
            <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
              <i className="fab fa-twitter" />
            </MKTypography>
            <MKTypography component="a" variant="body1" color="white" href="#">
              <i className="fab fa-google-plus" />
            </MKTypography>
          </MKBox>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
          zIndex: 1,
        }}
      >
        <Information />
        <Team />
        <Featuring />
        <Newsletter />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default WebDev;
